import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {Feature, Features$} from "src/app/models/features.model";
import {SuppliersFields} from "src/app/features/suppliers/suppliers-form.model";
import {AgGridAngular} from "ag-grid-angular";
import {FidelityMovementsFields, PrepaidMovementsFields} from "src/app/features/customers/customers.model";
import {CustomersFields} from "src/app/features/customers/components/customers-details/tab-customer/customer-form/customers-form.model";
import {CashMovements, Giftcards, Sales} from 'tilby-models';
import { StaticTokenSession } from 'tilby-models';
import { FileExporterFe } from '../../model/model';
import { PromotionsFe } from '../../model/model';
import { SaleItemsDeletedFe } from '../../model/model';
import { ItemFields } from 'src/app/features/items/models/items-form.model';
import { CategoriesFields } from 'src/app/features/items/components/items-module/categories-tab/categories.models';
import { ComponentsFields } from 'src/app/features/items/components/items-module/components-tab/components.models';
import { RawMaterialsFields } from 'src/app/features/items/components/items-module/raw-materials-tab/raw-materials.model';
import { DepartmentsFields } from 'src/app/features/items/components/items-module/departments-tab/departments.model';
import { VatRatesFields } from 'src/app/features/items/components/items-module/vat-rates-tab/vat-rates-model';
import { StockFields } from 'src/app/features/stock/stock-management/model/stock-model';
import { StockMovementSearchFe, StockMovementsFields } from 'src/app/features/stock/stock-movements/models/stock-movements.model';


interface TableProperties {
    selectedRows:any[];
    idsDeleting:number[];
    gridIstances: GridInstances;
}

type GridInstances = { [id in Feature ]:AgGridAngular };

@Injectable({
  providedIn: 'root'
})
export class GridService implements Features$ {
    //FOR SERVER SIDE TABLE (IT REQUIRES REFRESH)
    tableProperties :TableProperties = {selectedRows:[], idsDeleting:[], gridIstances:{} as GridInstances};
    suppliers$ = {
        flash: new Subject<SuppliersFields>(),
        data: new Subject<SuppliersFields[]>(),
    };
    customers$ = {
        flash: new Subject<CustomersFields>(),
        data: new Subject<CustomersFields[]>(),
    };
    prepaid$ = {
        flash: new Subject<(PrepaidMovementsFields&{isNew:boolean})|null>(),
        data: new Subject<PrepaidMovementsFields[]>(),
    };
    fidelity$ = {
        flash: new Subject<(FidelityMovementsFields&{isNew:boolean})|null>(),
        data: new Subject<FidelityMovementsFields[]>(),
    };
    history_sales$ = {
        flash: new Subject<Sales&{isNew:boolean}>(),
        data: new Subject<Sales[]>(),
        closeDetail: new Subject<void>(),
    };
    history_sales_data_sent$ = {
        flash: new Subject<Sales&{isNew:boolean}>(),
        data: new Subject<Sales[]>(),
    };
    history_e_invoices$ = {
        flash: new Subject<Sales&{isNew:boolean}>(),
        data: new Subject<Sales[]>(),
    };
    giftcards$ = {
        flash: new Subject<(Giftcards&{isNew:boolean})|null>(),
        data: new Subject<Giftcards[]>()
    };
    settings_um_static_token$ = {
        flash: new Subject<StaticTokenSession>(),
        data: new Subject<StaticTokenSession[]>(),
    };
    history_cash_movements$ = {
        flash: new Subject<CashMovements&{isNew:boolean}>(),
        data: new Subject<CashMovements[]>()
    };
    file_importer$ = {
        flash: new Subject<CashMovements&{isNew:boolean}>(),
        data: new Subject<CashMovements[]>()
    };
    file_exporter$ = {
        flash: new Subject<FileExporterFe&{isNew:boolean}>(),
        data: new Subject<FileExporterFe[]>()
    };
    promotions$ = {
        flash: new Subject<PromotionsFe>(),
        data: new Subject<PromotionsFe[]>(),
    };
    history_products_deleted$ = {
        flash: new Subject<SaleItemsDeletedFe>(),
        data: new Subject<SaleItemsDeletedFe[]>()
    };
    items$ = {
        flash: new Subject<ItemFields>(),
        data: new Subject<ItemFields[]>()
    };
    categories$ = {
        flash: new Subject<CategoriesFields>(),
        data: new Subject<CategoriesFields[]>()
    };
    components$ = {
        flash: new Subject<ComponentsFields>(),
        data: new Subject<ComponentsFields[]>()
    };
    raw_materials$ = {
        flash: new Subject<RawMaterialsFields>(),
        data: new Subject<RawMaterialsFields[]>()
    };
    departments$ = {
        flash: new Subject<DepartmentsFields>(),
        data: new Subject<DepartmentsFields[]>()
    };
    vat_rates$ = {
        flash: new Subject<VatRatesFields>(),
        data: new Subject<VatRatesFields[]>()
    };
    stock$ = {
        flash: new Subject<StockFields>(),
        data: new Subject<StockFields[]>()
    };
    stock_movements$ = {
        flash: new Subject<StockMovementsFields>(),
        data: new Subject<StockMovementsFields[]>()
    };
    stock_movements_search$ = {
        flash: new Subject<StockMovementSearchFe>(),
        data: new Subject<StockMovementSearchFe[]>()
    };
}
